import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

// export const SET_HEADER_DATE_FROM = "SET_HEADER_DATE_FROM";
// export const SET_HEADER_DATE_TO = "SET_HEADER_DATE_TO";
// export const SET_HEADER_UNIT = 'SET_HEADER_UNIT';

export const GET_SEVEN_DAY_TRANSACTION = 'GET_SEVEN_DAY_TRANSACTION';
export const GET_SEVEN_DAY_TRANSACTION_SUCCESS = 'GET_SEVEN_DAY_TRANSACTION_SUCCESS';
export const GET_SEVEN_DAY_TRANSACTION_FAILED = 'GET_SEVEN_DAY_TRANSACTION_FAILED';

export const GET_SEVEN_DAY_CSV = "GET_SEVEN_DAY_CSV";
export const GET_SEVEN_DAY_CSV_SUCCESS = "GET_SEVEN_DAY_CSV_SUCCESS";
export const GET_SEVEN_DAY_CSV_FAILED = "GET_SEVEN_DAY_CSV_FAILED";

export const GET_RECHARGE_WALLET_BALANCE = "GET_RECHARGE_WALLET_BALANCE"
export const GET_RECHARGE_WALLET_BALANCE_SUCCESS = "GET_RECHARGE_WALLET_BALANCE_SUCCESS";
export const GET_RECHARGE_WALLET_BALANCE_FAILED = "GET_RECHARGE_WALLET_BALANCE_FAILED";

export const GET_RECHARGE_WALLET_BALANCE_CSV = "GET_RECHARGE_WALLET_BALANCE_CSV"
export const GET_RECHARGE_WALLET_BALANCE_SUCCESS_CSV = "GET_RECHARGE_WALLET_BALANCE_SUCCESS_CSV";
export const GET_RECHARGE_WALLET_BALANCE_FAILED_CSV = "GET_RECHARGE_WALLET_BALANCE_FAILED_CSV";

export const GET_TOP_FIVE_RETAILERS = "GET_TOP_FIVE_RETAILERS";
export const GET_TOP_FIVE_RETAILERS_SUCCESS = "GET_TOP_FIVE_RETAILERS_SUCCESS";
export const GET_TOP_FIVE_RETAILERS_FAILED = "GET_TOP_FIVE_RETAILERS_FAILED";

export const GET_BOTTOM_FIVE_RETAILERS = "GET_BOTTOM_FIVE_RETAILERS";
export const GET_BOTTOM_FIVE_RETAILERS_SUCCESS = "GET_BOTTOM_FIVE_RETAILERS_SUCCESS";
export const GET_BOTTOM_FIVE_RETAILERS_FAILED = "GET_BOTTOM_FIVE_RETAILERS_FAILED";

export const GET_RECHARGE_DISTRIBUTION_API = "GET_DISTRIBUTION_API"
export const GET_RECHARGE_DISTRIBUTION_API_SUCCESS = "GET_DISTRIBUTION_API_SUCCESS"
export const GET_RECHARGE_DISTRIBUTION_API_FAILED = "GET_DISTRIBUTION_API_FAILED"

export const GET_RECHARGE_DIST_CSV_API = "GET_RECHARGE_DIST_CSV_API";
export const GET_RECHARGE_DIST_CSV_API_SUCCESS = "GET_RECHARGE_DIST_CSV_API_SUCCESS";
export const GET_RECHARGE_DIST_CSV_API_FAILED = "GET_RECHARGE_DIST_CSV_API_FAILED";

export const GET_RECHARGE_SALES_API = "GET_RECHARGE_SALES_API";
export const GET_RECHARGE_SALES_API_SUCCESS = "GET_RECHARGE_SALES_API_SUCCESS";
export const GET_RECHARGE_SALES_API_FAILED = "GET_RECHARGE_SALES_API_FAILED";

export const GET_RECHARGE_SALES_CSV_API = "GET_RECHARGE_SALES_CSV_API";
export const GET_RECHARGE_SALES_CSV_API_SUCCESS = "GET_RECHARGE_SALES_CSV_API_SUCCESS";
export const GET_RECHARGE_SALES_CSV_API_FAILED = "GET_RECHARGE_SALES_CSV_API_FAILED";

export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";

export const GET_RECHARGE_INSIGHTS_API = "GET_RECHARGE_INSIGHTS_API";
export const GET_RECHARGE_INSIGHTS_API_SUCCESS = "GET_RECHARGE_INSIGHTS_API_SUCCESS";
export const GET_RECHARGE_INSIGHTS_API_FAILED = "GET_RECHARGE_INSIGHTS_API_FAILED";

// export function setHeaderDate_From(payload) {
//     return {
//         type: SET_HEADER_DATE_FROM,
//         payload: payload
//     }
// }

// export function setHeaderDate_To(payload) {
//     return {
//         type: SET_HEADER_DATE_TO,
//         payload: payload
//     }
// }

// export function setHeaderUnit(payload) {
//     return {
//         type: SET_HEADER_UNIT,
//         payload: payload
//     }
// }

export function triggerFetchRechargeDistribution(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rechargeSalesDistribution`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_DISTRIBUTION_API,
            successAction: GET_RECHARGE_DISTRIBUTION_API_SUCCESS,
            failedAction: GET_RECHARGE_DISTRIBUTION_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        makeAPICall(params);
    }
}
export function triggerRechargeDistributionCsv(obj,callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rechargeSalesDistributionCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_DIST_CSV_API,
            successAction: GET_RECHARGE_DIST_CSV_API_SUCCESS,
            failedAction: GET_RECHARGE_DIST_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab: obj.tab
        }
        //setTimeout(function () { makeAPICall(params) }, 2000);
        makeAPICall(params);
    }
}

export function triggerFetchRechargeSalesAPI(obj){
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rechargeSales`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_SALES_API,
            successAction: GET_RECHARGE_SALES_API_SUCCESS,
            failedAction: GET_RECHARGE_SALES_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        makeAPICall(params);
    }
}

export function triggerFetchRechargeSalesCsvAPI(obj, callback){
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rechargeSalesCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_SALES_CSV_API,
            successAction: GET_RECHARGE_SALES_CSV_API_SUCCESS,
            failedAction: GET_RECHARGE_SALES_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab: obj.tab
        }
        makeAPICall(params);
    }
}
export function triggerFetchLastSevenDayTransaction(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rsTransaction`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SEVEN_DAY_TRANSACTION,
            successAction: GET_SEVEN_DAY_TRANSACTION_SUCCESS,
            failedAction: GET_SEVEN_DAY_TRANSACTION_FAILED,
            type: "POST"
        };
        makeAPICall(params)
    }
}

export function triggerFetchLastSevenDayCSV(obj, callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rsTransactionCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SEVEN_DAY_CSV,
            successAction: GET_SEVEN_DAY_CSV_SUCCESS,
            failedAction: GET_SEVEN_DAY_CSV_FAILED,
            callback: callback,
            type: "POST",
            tab: obj.tab
        };
        //setTimeout(function () { makeAPICall(params) }, 2000);
        makeAPICall(params);
    }
}


export function triggerFetchRechargeWalletBalance(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rsRechargeWallet`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_WALLET_BALANCE,
            successAction: GET_RECHARGE_WALLET_BALANCE_SUCCESS,
            failedAction: GET_RECHARGE_WALLET_BALANCE_FAILED,
            type: "POST"
        };
        makeAPICall(params)
    }
}

export function triggerFetchRechargeWalletBalanceCSV(obj, callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rsRechargeWalletCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_WALLET_BALANCE_CSV,
            successAction: GET_RECHARGE_WALLET_BALANCE_SUCCESS_CSV,
            failedAction: GET_RECHARGE_WALLET_BALANCE_FAILED_CSV,
            callback: callback,
            type: "POST",
            tab: obj.tab
        };
        //setTimeout(function () { makeAPICall(params) }, 2000);
        makeAPICall(params);
    }
}


export function triggerFetchTopRetailers(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rsTopFiveRetailer`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_TOP_FIVE_RETAILERS,
            successAction: GET_TOP_FIVE_RETAILERS_SUCCESS,
            failedAction: GET_TOP_FIVE_RETAILERS_FAILED,
            type: "POST"
        };
        makeAPICall(params)
    }
}


export function triggerFetchBottomRetailers(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}rsBottomFiveRetailer`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_BOTTOM_FIVE_RETAILERS,
            successAction: GET_BOTTOM_FIVE_RETAILERS_SUCCESS,
            failedAction: GET_BOTTOM_FIVE_RETAILERS_FAILED,
            type: "POST"
        };
        makeAPICall(params)
    }
}

export function fetchShowAlertRecharge() {
    return {
        type: SHOW_ALERT,
    }
}

export function hideAlertRecharge(){
    return {
        type: HIDE_ALERT
    }
}

export function triggerFetchRechargeInsightsAPI(obj) {
    return dispatch => {
        const params = {
            url: obj.url,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_RECHARGE_INSIGHTS_API,
            successAction: GET_RECHARGE_INSIGHTS_API_SUCCESS,
            failedAction: GET_RECHARGE_INSIGHTS_API_FAILED,
            type: "POST",
            extraData: obj.extraData,
        };
        makeAPICall(params);
    };
}
